import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const jsonToUri = (v, r, s) => {
  return encodeURIComponent(
    JSON.stringify(v, r, s)
      .replace(/[()'~_!*]/g, function (c) {
        // Replace ()'~_!* with \u0000 escape sequences
        return "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4);
      })
      .replace(/\{/g, "(") //    { -> (
      .replace(/\}/g, ")") //    } -> )
      .replace(/"/g, "'") //    " -> '
      .replace(/\:/g, "~") //    : -> ~
      .replace(/,/g, "_") //    , -> _
      .replace(/\[/g, "!") //    [ -> !
      .replace(/\]/g, "*") //    ] -> *
  );
};
const uriToJson = (t, r) => {
  return JSON.parse(
    decodeURIComponent(t)
      .replace(/\(/g, "{") //    ( -> {
      .replace(/\)/g, "}") //    ) -> }
      .replace(/'/g, '"') //    ' -> "
      .replace(/~/g, ":") //    ~ -> :
      .replace(/_/g, ",") //    _ -> ,
      .replace(/\!/g, "[") //    ! -> [
      .replace(/\*/g, "]"), //    * -> ]
    r
  );
};

// let cancelToken;
const contactUs = (data, fileBinaryData) => {
  const file = {
    "Content-Disposition": "form-data",
    "name":"file",
    "filename": data.FileName,
    "Content-Type": data.FileType
  }
  const bodyFormData = new FormData();
  bodyFormData.append("file", fileBinaryData)

  let jsonuri = jsonToUri(data);
  let uritojson = uriToJson(jsonuri);
  let finalObj = JSON.stringify(uritojson);
  return apiRequestType(
    apiTypes.POST,
    apiConstants.PROFILE.POST_CONTACT_US_NEW_COMPLAINT(finalObj),
    bodyFormData
  );
};

export default contactUs;
